import { useEffect, useState } from 'react';
import { css, cx } from 'linaria';
import { BookmarkFilledIcon } from 'components/icons/BookmarkFilledIcon';
import { useInView } from 'react-intersection-observer';
import { useHasChanged } from 'common/utilities/hooks/has-changed';
const bookmarkStyles = "b19radgi";
export const BookmarkIcon = ({
  newSaveCount = 0
}) => {
  const [show, setShow] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const saveCountChange = useHasChanged(newSaveCount.toString()); // 0 evals as false, needs to be string

  const [ref, inView] = useInView({
    threshold: 0.5
  });
  useEffect(() => {
    if (saveCountChange) {
      setHasChanged(true);
      setShow(false);
    }

    if (hasChanged && inView && newSaveCount !== 0) {
      setHasChanged(false);
      setShow(true);
    }
  }, [hasChanged, inView, newSaveCount, saveCountChange]);
  const bookmarkClassName = cx(bookmarkStyles, show && 'visible');
  return <span ref={ref} className={bookmarkClassName}>
      <BookmarkFilledIcon />
    </span>;
};

require("./bookmark-icon.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./bookmark-icon.js");